export default "__VITE_ASSET__OTCQhNaX__"